import styled from "styled-components";

export const StyledCell = styled.div`
    width: 50px;
    height: 50px;
    
    img {
        width: 100%;
        height: 100%;
    }
`;

